import React, { useState } from "react";

const SantaHelp = () => {
  const [showHelp, setShowHelp] = useState(false);

  return (
    <>
      <h5 className="pointer underline" onClick={() => setShowHelp(!showHelp)}>
        How it works?
      </h5>
      {showHelp && (
        <div className="padding-bottom-style">
          <p>
          In the most common case (no exclusion rules, pair each guest with
          another at random), enter the name of your guests one line at a time.
          Once done, press "Done" and you're all set: send the generated pairs
          to your guests (by mail, chat, whatever floats your boat) and your
          gifting can begin.
          </p>
        </div>
      )}
    </>
  );
};

export default SantaHelp;
